import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';

function KPITable({ kpis }) {
  // #region Data
  const { t } = useTranslation();

  const groupedKpis = useMemo(() => {
    const groups = [];

    kpis?.forEach((kpi) => {
      const key = kpi?.researchKpi?.researchKpiGroup.name;
      if (!groups[key]) {
        groups[key] = [];
      }

      groups[key].push(kpi);
    });

    return Object.values(groups);
  }, [kpis]);
  // #endregion

  return (
    <div className="grid">
      <div className="col-12">
        <div
          className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines p-datatable-gridlines"
          data-scrollselectors=".p-datatable-wrapper"
        >
          <div className="p-datatable-wrapper">
            <table className="p-datatable-table">
              <thead className="p-datatable-thead">
                <tr>
                  <th className="w-4rem text-center" style={{ minWidth: '4rem' }}>
                    {t('projectProposal.researchResult.kpis.fields.order')}
                  </th>
                  <th className="w-16rem text-center" style={{ minWidth: '8rem' }}>
                    {t('projectProposal.researchResult.kpis.fields.KPI')}
                  </th>
                  <th className="w-6rem text-center" style={{ minWidth: '4rem' }}>
                    {t('projectProposal.researchResult.kpis.fields.numberRegistration')}
                  </th>
                  <th className="w-16rem text-center" style={{ minWidth: '8rem' }}>
                    {t('projectProposal.researchResult.kpis.fields.content')}
                  </th>
                </tr>
              </thead>
              {groupedKpis?.map((kpiGroup) => (
                <tbody
                  className="p-datatable-tbody"
                  key={kpiGroup[0]?.researchKpi?.researchKpiGroup?.id}
                >
                  {kpiGroup?.map((kpi, index) => (
                    <tr key={kpi?.id ?? index}>
                      {index === 0 ? (
                        <td className="text-center font-bold" rowSpan={kpiGroup?.length}>
                          {kpi?.researchKpi?.researchKpiGroup?.name}
                          <span className="font-normal">
                            <br />
                            {kpi?.researchKpi?.researchKpiGroup?.desc}
                          </span>
                        </td>
                      ) : (
                        <td className="hidden" />
                      )}
                      <td>
                        {t('lang') === 'vi' ? kpi?.researchKpi.name : kpi?.researchKpi.englishName}
                      </td>
                      <td className="text-center">{kpi?.quantity || ''}</td>
                      <td>{kpi?.content}</td>
                    </tr>
                  ))}
                </tbody>
              ))}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default React.memo(KPITable);

KPITable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  kpis: PropTypes.array.isRequired,
};
